exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".eula-container .accept-msg{font-style:italic;font-size:14px;min-width:150px}.eula-container md-content{min-height:50px;flex-basis:auto;background-color:#f3f3f3;overflow-wrap:break-word;word-wrap:break-word}.eula-container md-content .eula-text{margin:0}.eula-container md-content .eula-text ol{counter-reset:section;list-style-type:none;padding-left:20px}.eula-container md-content .eula-text ol li:before{counter-increment:section;content:counters(section,\".\") \". \"}.eula-container md-content .eula-text li,.eula-container md-content .eula-text p{margin:10px 0}.eula-container .terms-button{margin-left:0}.eula-container md-dialog-actions{flex-shrink:0}.eula-container .gz-readonly{background-color:#ff5722;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!../~/@printos/gazelle/src/components/user/eula/eula.scss
// module id = 122
// module chunks = 0